import $ from 'jquery';

$(function(){
  //On Window Scroll Event for sticky modules
  $(window).on("scroll", e => {
    // console.log($(document).scrollTop());
    var pixelsTop = $(document).scrollTop();
    if (pixelsTop > 135) {
      $('.stickytitle').addClass("stick");
      $('.stickynav').addClass("stick");
    } else {
      $('.stickytitle').removeClass("stick");
      $('.stickynav').removeClass("stick");
    }
    if (pixelsTop > 465) {
      $('.contenttabs.arrow').addClass("sticky");
    } else {
      $('.contenttabs.arrow').removeClass("sticky");
    }
  });

  ( () => {
    const stickyElements = $( '.desktop-tabs, thead, tbody', $( '.contenttabs.vertical-table.desktop' ) ).get();
    const stickyPlaceholders = stickyElements.map( stickyElement => {
      const placeholder = document.createElement( stickyElement.tagName );
      placeholder.className = `${stickyElement.className || ''} placeholder`;
      placeholder.style.visibility = 'hidden';
      placeholder.style.display = 'none';
      $( placeholder ).insertBefore( stickyElement );
      return placeholder;
    } );

    $(window).on("scroll", e => {
      const isSticky = $(document).scrollTop() > 220;
      $( stickyElements ).toggleClass( 'sticky', isSticky );
      $( stickyPlaceholders ).toggle( isSticky );
    } );

    
    const $stickyNavLinks = $('div.stickynav a.nav-link');
    if( $stickyNavLinks.length > 0) {
      const url = window.location.pathname,
      urlRegExp = new RegExp(url.replace(/\/$/, '') + "$");
      $stickyNavLinks.each(function(this: HTMLAnchorElement) {
        if (urlRegExp.test(this.href.replace(/\/$/, ''))) {  
          $(this).addClass('current');  
        }
      });
    }
  } )();

});